module.exports = __webpack_public_path__ + "static/cs-logo-main-ecf8e74bcee99ef7bb7bae21ebbf9d75.png";